import { render, staticRenderFns } from "./Bundles.vue?vue&type=template&id=399fb2ca&"
import script from "./Bundles.vue?vue&type=script&lang=js&"
export * from "./Bundles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports